module.exports = __webpack_public_path__ + "img/breakfast_forbid.dfc99e99.png";